{
    "intl-msg:common-message.error.generic.headline": "Oh snap! Something went wrong.",
    "intl-msg:common-message.error.generic.message": "We could not load your data. Please try again.",
    "intl-msg:starterTemplate.moduleName": "Starter Template",
    "intl-msg:starterTemplate.sublink.more": "More",
    "intl-msg:starterTemplate.sublink.intro": "Introduction",
    "intl-msg:sci.moduleName": "Inbound Monitor",
    "intl-msg:sci.transport": "Transport",
    "intl-msg:sci.orderNumber": "Transport order number",
    "intl-msg:sci.ordered": "Transport ordered",
    "intl-msg:sci.pickup": "Pickup date / time window",
    "intl-msg:sci.delivery": "Delivery date",
    "intl-msg:sci.shipFrom": "Ship from",
    "intl-msg:sci.shipTo": "Ship to",
    "intl-msg:sci.carrier": "Carrier",
    "intl-msg:sci.plate": "Truck license plate",
    "intl-msg:sci.type": "Type",
    "intl-msg:sci.materials": "Material numbers",
    "intl-msg:sci.load": "Volume / Weight / Packaging",
    "intl-msg:sci.unknown": "Unknown",
    "intl-msg:sci.missed": "Missed",
    "intl-msg:sci.open": "Open",
    "intl-msg:sci.confirmed": "Confirmed",
    "intl-msg:sci.loading": "Loading transports…",
    "intl-msg:sci.loadError": "Could not load all transport data.",
    "intl-msg:sci.noTransports": "No transports found",
    "intl-msg:sci.tryFilters": "Clear the filters or try a different search.",
    "intl-msg:sci.reset": "Reset filters",
    "intl-msg:sci.retry": "Retry",
    "intl-msg:sci.allPlants": "All plants",
    "intl-msg:sci.allCarriers": "All carriers",
    "intl-msg:sci.dateRange": "Delivery date range",
    "intl-msg:sci.search": "Search transports ...",
    "intl-msg:sci.filter": "Filter",
    "intl-msg:sci.loadMore": "Load more",
    "intl-msg:sci.noData": "No transport data yet",
    "intl-msg:sci.awaitEvents": "Transport requests and confirmed transports appear after SCM events arrive.",
    "intl-msg:sci.transportOrderMissing": "Transport order missing",
    "intl-msg:sci.requestedPickup": "Requested pickup",
    "intl-msg:sci.estimatedPickup": "Estimated pickup",
    "intl-msg:sci.pickupWindowMissing": "No confirmed window",
    "intl-msg:sci.pickupDateOnly": "Date matched; time not compared",
    "intl-msg:sci.loadMoreRequests": "Load more transport requests",
    "intl-msg:sci.loadMoreTransports": "Load more transports",
    "intl-msg:sci.graph.title": "Transport graph",
    "intl-msg:sci.graph.requests": "Transport requests",
    "intl-msg:sci.graph.request": "Transport request",
    "intl-msg:sci.graph.transports": "Transports",
    "intl-msg:sci.graph.transport": "Transport",
    "intl-msg:sci.graph.details": "Details",
    "intl-msg:sci.graph.select": "Select a card or connection to inspect its details.",
    "intl-msg:sci.graph.clearSelection": "Clear selection",
    "intl-msg:sci.graph.notLoaded": "Not in loaded requests",
    "intl-msg:sci.graph.subset": "Loaded subset",
    "intl-msg:sci.graph.loaded": "Loaded results",
    "intl-msg:sci.graph.notice": "Connections reflect the loaded results. An unconnected card does not imply completion or missing allocation.",
    "intl-msg:sci.graph.dateChanged": "Pickup date changed",
    "intl-msg:sci.graph.timeChanged": "Pickup time changed",
    "intl-msg:sci.graph.notComparable": "Pickup cannot be compared",
    "intl-msg:sci.graph.handlingUnits": "Handling units",
    "intl-msg:sci.graph.fit": "Fit to view",
    "intl-msg:sci.graph.zoomIn": "Zoom in",
    "intl-msg:sci.graph.zoomOut": "Zoom out",
    "intl-msg:sci.graph.resetView": "Reset view",
    "intl-msg:sci.graph.layoutError": "Automatic layout is unavailable. Cards are shown in two columns.",
    "intl-msg:sci.graph.canvas": "Transport request and transport graph",
    "intl-msg:sci.graph.variant": "UI variant",
    "intl-msg:sci.graph.original": "Original",
    "intl-msg:sci.graph.graph": "Graph",
    "intl-msg:sci.graph.preview": "Fixture preview · existing frontend data · not connected to the backend",
    "intl-msg:sci.graph.unitCount": "{count, plural, one {# handling unit} other {# handling units}}",
    "intl-msg:sci.graph.inspectConnection": "Inspect connection",
    "intl-msg:sci.graph.arrange": "Arrange cards",
    "intl-msg:sci.graph.map": "Graph overview map",
    "intl-msg:sci.graph.previewDemo": "Demo controls publish to the backend and open the live graph.",
    "intl-msg:sci.graph.referenceOnly": "Reference only",
    "intl-msg:sci.material.article": "Article Number / Name",
    "intl-msg:sci.material.status": "Status",
    "intl-msg:sci.material.delivery": "Projected delivery",
    "intl-msg:sci.material.plant": "Plant / Unloading point",
    "intl-msg:sci.material.storage": "Goods receipt",
    "intl-msg:sci.material.supplier": "Supplier",
    "intl-msg:sci.material.actions": "Actions",
    "intl-msg:sci.material.onPlan": "On Plan",
    "intl-msg:sci.material.shortfall": "Quantity shortfall",
    "intl-msg:sci.material.excess": "Excess quantity",
    "intl-msg:sci.material.early": "Early planned delivery",
    "intl-msg:sci.material.late": "Late planned delivery",
    "intl-msg:sci.material.incomplete": "Incomplete data",
    "intl-msg:sci.material.dateUnknown": "Required delivery date unknown",
    "intl-msg:sci.material.notSent": "Request not sent",
    "intl-msg:sci.material.awaiting": "Awaiting confirmation",
    "intl-msg:sci.material.notComparable": "Not comparable",
    "intl-msg:sci.material.partial": "Partially confirmed",
    "intl-msg:sci.material.confirmedExcess": "Excess confirmed",
    "intl-msg:sci.material.covered": "Confirmed quantity covered",
    "intl-msg:sci.material.ordered": "Material Ordered",
    "intl-msg:sci.material.planned": "Transport Planned",
    "intl-msg:sci.material.confirmed": "Transport Confirmation",
    "intl-msg:sci.material.completed": "Completed",
    "intl-msg:sci.material.quantityDeviation": "Quantity deviation",
    "intl-msg:sci.material.dateDeviation": "Planning-date deviation",
    "intl-msg:sci.material.pending": "Pending",
    "intl-msg:sci.material.unknown": "Unknown",
    "intl-msg:sci.material.amount": "Amount",
    "intl-msg:sci.material.allPlants": "All plants",
    "intl-msg:sci.material.search": "Search article …",
    "intl-msg:sci.material.reset": "Reset",
    "intl-msg:sci.material.viewDetails": "View Details",
    "intl-msg:sci.material.previous": "Previous",
    "intl-msg:sci.material.next": "Next",
    "intl-msg:sci.material.loading": "Loading materials",
    "intl-msg:sci.material.noData": "No material data available yet.",
    "intl-msg:sci.material.empty": "No materials match this view.",
    "intl-msg:sci.material.tryFilters": "Adjust the article, plant or search.",
    "intl-msg:sci.material.loadError": "Materials could not be loaded.",
    "intl-msg:sci.material.retry": "Retry",
    "intl-msg:sci.material.unknownArticle": "Article details unknown",
    "intl-msg:sci.material.nameUnknown": "Name unavailable",
    "intl-msg:sci.material.details": "Material delivery details",
    "intl-msg:sci.material.detailError": "Material details could not be loaded. The material may have been removed.",
    "intl-msg:sci.material.nextDates": "Next delivery dates",
    "intl-msg:sci.material.requiredDate": "Required delivery",
    "intl-msg:sci.material.plannedDate": "Planned delivery",
    "intl-msg:sci.material.uncovered": "Uncovered by plan",
    "intl-msg:sci.material.excessAmount": "Excess in plan",
    "intl-msg:sci.material.sentQuantity": "Quantity in sent request",
    "intl-msg:sci.material.shortfallDetected": "Shortfall detected",
    "intl-msg:sci.material.planReduced": "Transport quantity planned too low. Open: {amount}.",
    "intl-msg:sci.material.planExcess": "Transport quantity exceeds the requirement by {amount}.",
    "intl-msg:sci.material.onPlanDetail": "Planned quantity and delivery date match the requirement.",
    "intl-msg:sci.material.incompleteDetail": "Some source information is unavailable. Unknown quantities are not treated as zero.",
    "intl-msg:sci.material.articleSection": "Article",
    "intl-msg:sci.material.partNumber": "Part number",
    "intl-msg:sci.material.description": "Description",
    "intl-msg:sci.material.unit": "Measurement unit",
    "intl-msg:sci.material.deliverySection": "Delivery & transport",
    "intl-msg:sci.material.unloading": "Unloading point",
    "intl-msg:sci.material.storagePlace": "Goods receipt storage",
    "intl-msg:sci.material.transportType": "Transport type",
    "intl-msg:sci.material.partners": "Partners",
    "intl-msg:sci.material.carrier": "Carrier",
    "intl-msg:sci.material.arrivalUnavailable": "Carrier-confirmed arrival is unavailable.",
    "intl-msg:sci.material.sourceSection": "Source references",
    "intl-msg:sci.material.sourceGoods": "Source goods references",
    "intl-msg:sci.material.request": "Transport request",
    "intl-msg:sci.material.pickup": "Requested pickup",
    "intl-msg:sci.material.from": "Ship from",
    "intl-msg:sci.material.sentAt": "Sent at",
    "intl-msg:sci.material.viewRequest": "View transport request",
    "intl-msg:sci.material.transport": "Confirmed transport",
    "intl-msg:sci.material.confirmedPickup": "Confirmed pickup window",
    "intl-msg:sci.material.retryRequest": "Retry request details",
    "intl-msg:sci.material.retryTransport": "Retry transport details",
    "intl-msg:sci.material.articleFilter": "Article filter",
    "intl-msg:sci.material.findArticle": "Find article",
    "intl-msg:sci.material.articles": "Articles",
    "intl-msg:sci.material.noArticleFound": "No articles found.",
    "intl-msg:sci.material.productGroupsUnavailable": "Product groups are unavailable in the source data.",
    "intl-msg:sci.material.noPlantFound": "No plants found.",
    "intl-msg:sci.material.onePlant": "Plant selected",
    "intl-msg:sci.material.manyPlants": "Plants selected",
    "intl-msg:sci.material.previousMaterial": "Previous material",
    "intl-msg:sci.material.nextMaterial": "Next material",
    "intl-msg:sci.material.fullscreen": "Toggle fullscreen",
    "intl-msg:sci.material.orderedTip": "Original required quantity referenced by this request: {quantity}.",
    "intl-msg:sci.material.plannedTip": "Planned quantity: {quantity}. Request state: {status}.",
    "intl-msg:sci.material.confirmedTip": "Carrier-confirmed quantity: {quantity}. {state}.",
    "intl-msg:sci.material.stageSummary": "Material Ordered: {ordered}; Transport Planned ({status}): {planned}; Transport Confirmation: {confirmed}. {state}.",
    "intl-msg:sci.material.unresolved": "{count} transport groups have unresolved request references. Coverage updates when the requests arrive.",
    "intl-msg:sci.material.pageCount": "{from}–{to} / {total}",
    "intl-msg:sci.material.noOriginalDate": "Original required delivery unknown",
    "intl-msg:sci.material.noPlannedQuantity": "Planned quantity unknown",
    "intl-msg:sci.material.pcs": "Pcs",
    "intl-msg:sci.material.kg": "kg",
    "intl-msg:sci.material.sourceId": "Request ID",
    "intl-msg:sci.material.noCarrier": "Carrier unavailable",
    "intl-msg:sci.material.plannedState": "Request state: {status}",
    "intl-msg:sci.materialView": "Material",
    "intl-msg:tree.treeOptionsTooltip": "Customize view",
    "intl-msg:sci.demoScenario.title": "Import scenario",
    "intl-msg:sci.demoScenario.intro": "Paste generated scenario JSON. Publishing uses your current browser login.",
    "intl-msg:sci.demoScenario.environment": "Target environment: {url}",
    "intl-msg:sci.demoScenario.replacement": "Existing IDs are replaced with complete snapshots. Changes affect everyone using this environment.",
    "intl-msg:sci.demoScenario.json": "Scenario JSON",
    "intl-msg:sci.demoScenario.review": "Review scenario",
    "intl-msg:sci.demoScenario.edit": "Edit JSON",
    "intl-msg:sci.demoScenario.close": "Close",
    "intl-msg:sci.demoScenario.publish": "Publish {count, plural, one {# remaining record} other {# remaining records}}",
    "intl-msg:sci.demoScenario.publishing": "Publishing…",
    "intl-msg:sci.demoScenario.requests": "{count, plural, one {# request} other {# requests}}",
    "intl-msg:sci.demoScenario.transports": "{count, plural, one {# transport} other {# transports}}",
    "intl-msg:sci.demoScenario.order": "Requests publish first, followed by transports. The batch stops on the first failure; already acknowledged records are skipped when you retry.",
    "intl-msg:sci.demoScenario.resource": "Resource",
    "intl-msg:sci.demoScenario.id": "Record ID",
    "intl-msg:sci.demoScenario.status": "Status",
    "intl-msg:sci.demoScenario.request": "Request",
    "intl-msg:sci.demoScenario.transport": "Transport",
    "intl-msg:sci.demoScenario.pending": "Pending",
    "intl-msg:sci.demoScenario.acknowledged": "Acknowledged · revision {revision}",
    "intl-msg:sci.demoScenario.progress": "{done} of {total} records acknowledged",
    "intl-msg:sci.demoScenario.complete": "All records acknowledged. Views update as events are processed.",
    "intl-msg:sci.demoScenario.failed": "Publication stopped. Earlier records remain published. Retry the remaining records; the failed submission may already have reached the backend.",
    "intl-msg:sci.demoScenario.auth": "Your session could not publish this record. Sign in with an account that can access demo publication, then retry.",
    "intl-msg:sci.demoScenario.invalid": "Scenario could not be read: {detail}",
    "intl-msg:sci.demoScenario.projection": "Acknowledgement confirms event publication, not that the record is already visible in the views.",
    "intl-msg:sci.demoScenario.newBatch": "Edit as new batch",
    "intl-msg:sci.demoScenario.keepOpen": "Keep this page open to retain retry progress. A new batch or page reload can publish the same IDs again as updates.",
    "intl-msg:sci.demoScenario.example": "Load example with new IDs"
}
